<script lang="ts">
  import ToggleLabelButton from '$shared/atoms/ToggleLabelButton/ToggleLabelButton.svelte';
  import Label from '$provider/constants/Label';
  import type { ProfileMergeList } from '$provider/models/ProfileMergeList';

  interface Props {
    item: ProfileMergeList;
    onchange?: (e: Event) => void;
  }

  let { item, onchange }: Props = $props();

  let isDisabled = $derived(item.alert?.isActionBlocked);
  let actionLabel =
    $derived((isDisabled && Label.DontAdd) || (item.props?.checked && Label.Add) || Label.Ignore);
</script>

<ToggleLabelButton
  {actionLabel}
  disabled={isDisabled}
  checked={item.props?.checked}
  name={`${item.label}-${item.id}`}
  {onchange}
/>
